import store from '@state/store'
import router from '@router'

const errorResponseHandler = error => {
    store.dispatch('notifications/setError', {
        error: error.response,
    })

    return Promise.reject(error)
}

const error401Handler = error => {
    if (error.response.data.code === 401) {
        store.dispatch('auth/logOut')
        router.push('/login')
    }
}

const applyBaseInterceptors = axiosInstance => {
    axiosInstance.interceptors.response.use(
        response => response,
        errorResponseHandler
    )
}

const apply401Interceptors = axiosInstance => {
    axiosInstance.interceptors.response.use(
        response => response,
        error401Handler
    )
}

export default {
    use(axiosInstance) {
        applyBaseInterceptors(axiosInstance)
        apply401Interceptors(axiosInstance)
    },
}
